export default __webpack_public_path__ + "static/media/responsive-icon-24441.a2ce31a6.png";